import {
  BRAZIL_INFORMED_BEFOREHAND_DAYS_OPTIONS,
  BRAZIL_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS,
  DEFAULT_INFORMED_BEFOREHAND_DAYS_OPTIONS,
  DEFAULT_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS,
  SAUDI_INFORMED_BEFOREHAND_DAYS_OPTIONS,
  SAUDI_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS,
  TR_SHY_INFORMED_BEFOREHAND_DAYS_OPTIONS,
  TR_SHY_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS,
} from "../../settings/constants";
import { InformedBeforehand } from "../types/intake-funnel";
import { ClaimDetails } from "../../funnels/pre-eligibility/state/preEligibilityState";

type InformedBeforehandOptions = Readonly<Array<InformedBeforehand>>;
type InformedBeforehandOptionsWithTranslations = Partial<
  Record<Readonly<InformedBeforehand>, string>
>;

export function useInformedBeforehandOptions({
  potentialRegulation,
}: {
  potentialRegulation: ClaimDetails["potentialRegulation"];
}): {
  options: InformedBeforehandOptions;
  optionsWithTranslations: InformedBeforehandOptionsWithTranslations;
} {
  let options: InformedBeforehandOptions = DEFAULT_INFORMED_BEFOREHAND_DAYS_OPTIONS;
  let optionsWithTranslations: InformedBeforehandOptionsWithTranslations =
    DEFAULT_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS;

  if (potentialRegulation === "brazil") {
    options = BRAZIL_INFORMED_BEFOREHAND_DAYS_OPTIONS;
    optionsWithTranslations = BRAZIL_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS;
  }

  if (potentialRegulation === "tr_shy") {
    options = TR_SHY_INFORMED_BEFOREHAND_DAYS_OPTIONS;
    optionsWithTranslations = TR_SHY_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS;
  }

  if (potentialRegulation === "saudi_arabia") {
    options = SAUDI_INFORMED_BEFOREHAND_DAYS_OPTIONS;
    optionsWithTranslations = SAUDI_INFORMED_BEFOREHAND_OPTIONS_WITH_TRANSLATIONS;
  }

  return {
    options,
    optionsWithTranslations,
  };
}
